import { CustomPaginator } from './call-history-list/CustomPaginatorConfiguration';
var ɵ0 = CustomPaginator();
var CallHistoryModule = /** @class */ (function () {
    function CallHistoryModule() {
    }
    return CallHistoryModule;
}());
export { CallHistoryModule };
export { ɵ0 };
